import { Badge } from "@/components/ui/Badge";
import type { WorkflowStatus } from "../types";

const TAGS: Record<WorkflowStatus, { label: string; variant: "green" | "blue" | "default" }> = {
  "in-use": { label: "In use", variant: "green" },
  planned: { label: "Planned", variant: "blue" },
  archived: { label: "Archived", variant: "default" },
};

/** A small tag with the status of a workflow. */
export const StatusTag = ({ status }: { status: WorkflowStatus }) => (
  <Badge variant={TAGS[status].variant}>{TAGS[status].label}</Badge>
);
